// 🗂️ B376 (AI_156) — O STATUS DE INSCRIÇÃO FOSSILIZADO QUE IA PARA A IA
// ─────────────────────────────────────────────────────────────
// A análise de um paciente TRANSPLANTADO EM 2020 relatou: "pendência
// administrativa: o cadastro mantém status 'lista_espera' (inscrição em
// 09/12/2015). Atualizar junto ao serviço." (leitura cega do B363, 30/10/2026.)
//
// A IA não alucinou — ela leu um campo MORTO. Ninguém atualiza
// `statusInscricao` depois do transplante, e o sistema NÃO o usa como verdade:
// a fase pré/lista/pós é derivada de RGCT + dataTransplante (memória
// [[classificacao-status-transplante]]). Mandávamos à IA um dado que nós
// mesmos não respeitamos, e ela gastou uma recomendação com ele.
//
// MAS o campo não é sempre morto: um paciente pode ser **re-listado para
// RETRANSPLANTE**, e aí "lista_espera" é informação crítica. O que separa os
// dois casos é a data da inscrição em relação à do transplante. Por isso aqui
// não se apaga por reflexo:
//   • inscrição DEPOIS do transplante → re-listagem: passa INTACTA;
//   • inscrição ANTES/no mesmo dia    → é a listagem que terminou naquele
//                                        transplante: sai (fóssil);
//   • transplante SEM data de inscrição → não há como decidir: passa com
//     RÓTULO, para a IA não a ler como situação atual. Esconder arriscaria
//     calar uma re-listagem real, e omitir dado clínico é pior que rotular.
// ─────────────────────────────────────────────────────────────

export type EntradaStatusInscricao = {
  statusInscricao?: string;
  dataInscricao?: string;
  dataTransplante?: string;
};

/** Só compara quando as duas datas são ISO (aaaa-mm-dd) — ordem lexicográfica basta. */
const ehIso = (d?: string): boolean => /^\d{4}-\d{2}-\d{2}/.test(String(d || ""));

export function statusInscricaoParaIA({
  statusInscricao,
  dataInscricao,
  dataTransplante,
}: EntradaStatusInscricao): string | undefined {
  if (!statusInscricao) return undefined;
  if (!dataTransplante) return statusInscricao; // pré-Tx: o status é o estado real

  if (ehIso(dataInscricao) && ehIso(dataTransplante)) {
    // Re-listagem para retransplante: inscrição posterior ao transplante.
    if (String(dataInscricao) > String(dataTransplante)) return statusInscricao;
    return undefined; // fóssil da listagem que terminou no transplante
  }
  return `${statusInscricao} (status da inscrição PRÉ-transplante; não é atualizado após o transplante — NÃO trate como situação atual nem recomende correção administrativa)`;
}
